/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Requireauth_Notifications_Title1Inputs */

const he_auth_requireauth_notifications_title1 = /** @type {(inputs: Auth_Requireauth_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התחברו כדי ליצור התראות`)
};

const en_auth_requireauth_notifications_title1 = /** @type {(inputs: Auth_Requireauth_Notifications_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to create notifications`)
};

/**
* | output |
* | --- |
* | "Sign in to create notifications" |
*
* @param {Auth_Requireauth_Notifications_Title1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const auth_requireauth_notifications_title1 = /** @type {((inputs?: Auth_Requireauth_Notifications_Title1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Requireauth_Notifications_Title1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_requireauth_notifications_title1(inputs)
	return en_auth_requireauth_notifications_title1(inputs)
});
export { auth_requireauth_notifications_title1 as "auth_requireAuth_notifications_title" }